import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLoading = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={21} fill="none" {...props}>
    <path fill="#616061" d="M16 17.5H8v-2h5v-10H8v-2h8z" />
    <path fill="#616061" d="M5 9.5v-3h1l4 4-4 4H5v-3H0v-2z" />
  </svg>
);
export default SvgLoading;
